/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ManageNotificationsDto } from '../models/ManageNotificationsDto';
import type { UserSettingsDto } from '../models/UserSettingsDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class NotificationService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @param requestBody
     * @returns UserSettingsDto
     * @throws ApiError
     */
    public manageNotifications0(
        requestBody: ManageNotificationsDto,
    ): CancelablePromise<UserSettingsDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/notification/toggle',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody
     * @returns UserSettingsDto
     * @throws ApiError
     */
    public manageNotifications1(
        requestBody: ManageNotificationsDto,
    ): CancelablePromise<UserSettingsDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/notification/manage',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
